module.exports = __webpack_public_path__ + "static/media/hmc-logo.99854bbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/brand/brands/hmc/media/hmc-logo.png
// module id = 847
// module chunks = 0